import { connect } from "react-redux";
import { connect as formikConnect } from "formik";
import sortBy from "lodash/sortBy";
import { isBrokerSelector } from "selectors/currentUser";
import { nonFakePortfoliosSelector } from "selectors/portfolio";

import PortfolioAsset from "./PortfolioAsset";

const mapStateToProps = (state) => ({
  isBroker: isBrokerSelector(state),
  assetNames: state.assetNames,
  portfolios: sortBy(nonFakePortfoliosSelector(state), ["name"]),
});

export default connect(mapStateToProps)(formikConnect(PortfolioAsset));
